import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { compose } from 'recompose'

import { Form } from 'components'

export const AI_ASSISTANT_FORM = 'learning_AiAssistant'

interface AiAssistantFormValues {
  aiEnabled: boolean
}

interface AiAssistantFormProps {
  handleSubmit: (e: any) => () => void
  onSubmit: (fields: AiAssistantFormValues) => void
}

const AiAssistantForm: React.FC<AiAssistantFormProps> = ({
  handleSubmit,
  onSubmit,
}) => (
  <Form flex={1} onSubmit={handleSubmit(onSubmit)}>
    <Form.Row>
      <Form.Row.Item>
        <Field
          component={Form.Switch}
          name="aiEnabled"
        />
      </Form.Row.Item>
    </Form.Row>
  </Form>
)

const enhance = compose(reduxForm({ form: AI_ASSISTANT_FORM }))

export default enhance(AiAssistantForm)
